import { RootState } from '@app/store/types';

import { ContractLinkCreateUpload } from './state';

export const getContractLinkCreateState = (state: RootState) => state.contractLinkCreate;
export const getConfirmedThatFieldCannotBeModified = (state: RootState): boolean =>
  getContractLinkCreateState(state).confirmedThatFieldCannotBeModified;
export const getUpload = (state: RootState): ContractLinkCreateUpload =>
  getContractLinkCreateState(state).upload;
export const getFileName = (state: RootState) => getUpload(state).fileName;
export const getLoadingStatus = (state: RootState) => getUpload(state).loadingStatus;
export const getMaxSigningPerParticipant = (state: RootState) =>
  getContractLinkCreateState(state).maxSigningPerParticipant;
export const getMaxSigningPerParticipantLimit = (state: RootState) =>
  getContractLinkCreateState(state).maxSigningPerParticipantLimit;
export const getLabels = (state: RootState) => getContractLinkCreateState(state).labels;
